import React from 'react'
import { connect } from 'react-redux'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import DisposalFacilitiesTable from '../RateTables/DisposalFacilitiesTable'

const useStyles = makeStyles((theme) => ({
  root: { width: '100%', minHeight: '100vh', backgroundColor: '#fff' },
  header: { padding: theme.spacing(2, 3, 0), display: 'flex', alignItems: 'center', gap: theme.spacing(2) },
  content: { padding: theme.spacing(2, 3) }
}))

const DisposalFacilitiesDashboard = ({ url }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Box className={classes.header}>
        <Typography variant="h5">Disposal Facilities</Typography>
      </Box>
      <Box className={classes.content}>
        <DisposalFacilitiesTable url={url} />
      </Box>
    </div>
  )
}

const mapStateToProps = (state) => ({
  url: state.url
})

export default connect(mapStateToProps)(DisposalFacilitiesDashboard)
